import { EventListeners, MinzeElement, Reactive } from 'minze'
import { Font } from '../../constants'
import { Callback } from '../../modules/callback'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'
import { Routing } from '../../modules/routing'
import { EMAIL_REGEX, PASSWORD_REGEX, unescapeHtml } from '../../modules/utils'

Locale.getInstance().registerKeySet('fr', 'signup', {
  menu: {
    title: 'Connectez-vous',
    subtitle: "Connectez-vous pour retrouver vos favoris et des suggestions d'activités.",
    login: 'Se connecter',
    google: 'Continuer avec Google',
    facebook: 'Continuer avec Facebook',
    toggle: {
      signup: 'Inscription',
      login: 'Connexion',
    },
  },
  form: {
    title: 'Pas encore de compte?',
    subtitle: "En vous inscrivant, vous recevrez des suggestions d'activités selon vos goûts.",
    notice: `En créant un compte, vous confirmez que vous avez 14 ans ou plus et vous acceptez nos <a href='${MainModule.getInstance().getRouting().getRoute('termsOfUse')}' target='_blank'>Conditions d'utilisations</a> et <a href='${MainModule.getInstance().getRouting().getRoute('privacyPolicy')}' target='_blank'>politique de confidentialité</a>.`,
    divider: 'OU',
  },
  email: {
    label: 'Adresse courriel',
    placeholder: 'Entrez votre email',
  },
  password: {
    label: 'Mot de passe',
    placeholder: 'Mot de passe',
    tooltip: {
      title: 'Critères du mot de passe:',
      point1: '8 caractères minimum',
      point2: 'Au moins une majuscule',
      point3: 'Au moins une minuscule',
      point4: 'Au moins un chiffre',
      point5: 'Au moins un caractère spécial',
    },
  },
  confirmPassword: {
    label: 'Confirmer le mot de passe',
    placeholder: 'Confirmer',
    tooltip: 'Votre mot de passe doit être identique à celui entré précédemment',
  },
  communicationsCheckboxesLabel: 'Communications',
  consentsCheckboxesLabel: 'Consentements',
  confirmPolicy: `J'accepte la <a href='${MainModule.getInstance().getRouting().getRoute('privacyPolicy')}' target='_blank'>politique de confidentialité.</a>`,
  confirmTerms: `J'accepte les <a href='${MainModule.getInstance().getRouting().getRoute('termsOfUse')}' target='_blank'>conditions d'utilisation.</a>`,
  confirmAge:
    "J'atteste que je suis une personne de plus de 14 ans. Je confirme que je suis apte à communiquer ces informations à La Vitrine Culturelle.",
  submit: "M'inscrire",
  alreadyAccount: 'Déjà un compte? <u>Se connecter</u>',
  acceptCommunications:
    "Pour en profiter, j'accepte de recevoir des communications liées à mes favoris.",
  subscribeNewsletter: "Pour ne rien manquer, je souhaite m'abonner à l'infolettre de La Vitrine.",
  errors: {
    firstName: 'Veuillez entrer votre prénom',
    lastName: 'Votre nom',
    email: 'Veuillez entrer votre adresse e-mail',
    emailInvalid: 'Courriel invalide',
    password: 'Veuillez entrer un mot de passe',
    passwordNotMatch: 'Les mots de passe ne correspondent pas',
    passwordCriterias:
      'Votre mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial',
    confirmPassword: 'Les mots de passe ne correspondent pas',
    passwordLength: 'Le mot de passe doit contenir au moins 8 caractères',
    general: 'Erreur lors de la création du compte',
    confirmPolicy:
      "Vous devez accepter les conditions d'utilisation et la politique de confidentialité.",
    confirmTerms:
      "Vous devez accepter les conditions d'utilisation et la politique de confidentialité.",
    confirmAge: 'Vous devez confirmer votre âge.',
    emailAlreadyExists: 'Cette adresse e-mail est déjà utilisée',
    emailAlreadyExistsWithProvider: {
      'google.com': 'Cette adresse e-mail est déjà utilisée avec Google',
      'facebook.com': 'Cette adresse e-mail est déjà utilisée avec Facebook',
      password: 'Cette adresse e-mail est déjà utilisée avec un mot de passe',
    },
  },
  providers: {
    google: 'Continuer avec Google',
    facebook: 'Continuer avec Facebook',
  },
})

Locale.getInstance().registerKeySet('en', 'signup', {
  menu: {
    title: 'Login',
    subtitle: 'Login to find your favorites and activity suggestions.',
    login: 'Login',
    google: 'Continue with Google',
    facebook: 'Continue with Facebook',
    toggle: {
      signup: 'Sign up',
      login: 'Login',
    },
  },
  form: {
    title: "Don't have an account?",
    subtitle: 'By signing up, you will receive activity suggestions based on your preferences.',
    notice: `By creating an account, you confirm that you are 14 years of age or older and agree to our <a href='${MainModule.getInstance().getRouting().getRoute('termsOfUse')}' target='_blank'>Terms of Use</a> and <a href='${MainModule.getInstance().getRouting().getRoute('privacyPolicy')}' target='_blank'>Privacy Policy</a>.`,
    divider: 'OR',
  },
  email: {
    label: 'Email',
    placeholder: 'Enter your email',
  },
  password: {
    label: 'Password',
    placeholder: 'Password',
    tooltip: {
      title: 'Password requirements:',
      point1: '8 characters minimum',
      point2: 'At least one uppercase letter',
      point3: 'At least one lowercase letter',
      point4: 'At least one number',
      point5: 'At least one special character',
    },
  },
  confirmPassword: {
    label: 'Confirm password',
    placeholder: 'Confirm',
    tooltip: 'Your password must be identical to the one entered previously',
  },
  communicationsCheckboxesLabel: 'Communications',
  consentsCheckboxesLabel: 'Consents',
  confirmPolicy: `I agree to the <a href='${MainModule.getInstance().getRouting().getRoute('privacyPolicy')}' target='_blank'>privacy policy.</a>`,
  confirmTerms: `I agree to the <a href='${MainModule.getInstance().getRouting().getRoute('termsOfUse')}' target='_blank'>terms of use.</a>`,
  confirmAge:
    'I hereby certify that I am over 14 years of age and am qualified to communicate this information to La Vitrine Culturelle.',
  submit: 'Subscribe',
  alreadyAccount: 'Already have an account? <u>Sign in</u>',
  acceptCommunications: 'I want to receive notifications linked to my preferences.',
  subscribeNewsletter: " I want to subscribe to La Vitrine's newsletter.",
  errors: {
    firstName: 'Please enter your first name',
    lastName: 'Last name',
    email: 'Please enter your email address',
    emailInvalid: 'Invalid e-mail',
    password: 'Please enter a password',
    passwordNotMatch: 'Passwords do not match',
    passwordCriterias:
      'Your password must have at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character',
    passwordLength: 'Password must be at least 8 characters long',
    confirmPassword: 'The passwords do not match',
    general: 'Error while creating account',
    confirmPolicy: 'You must accept the terms of use and privacy policy.',
    confirmTerms: 'You must accept the terms of use and privacy policy.',
    confirmAge: 'You must confirm your age.',
    emailAlreadyExists: 'This email address is already used',
    emailAlreadyExistsWithProvider: {
      'google.com': 'This email address is already used with Google',
      'facebook.com': 'This email address is already used with Facebook',
      password: 'This email address is already used with a password',
    },
  },
  providers: {
    google: 'Continue with Google',
    facebook: 'Continue with Facebook',
  },
})

export interface LvcSignup {
  passwordLengthValid: boolean
  passwordUpperCaseValid: boolean
  passwordLowerCaseValid: boolean
  passwordNumberValid: boolean
  passwordSpecialCharValid: boolean
  valuePasswordInput: string
  tooltipOpened: boolean
  email: string
  password: string
  confirmPassword: string
}

export class LvcSignup extends MinzeElement {
  handleInputCb = Callback.attach(this.handleInput.bind(this))
  private onChangeCb: string = ''

  reactive: Reactive = [
    ['passwordLengthValid', false],
    ['passwordUpperCaseValid', false],
    ['passwordLowerCaseValid', false],
    ['passwordNumberValid', false],
    ['passwordSpecialCharValid', false],
    ['valuePasswordInput', ''],
    ['tooltipOpened', false],
    ['submitButtonDisabled', true],
    ['allPasswordCriteriasMet', true],
    ['email', ''],
    ['password', ''],
    ['confirmPassword', ''],
    ['loading', false],
  ]
  errors: any = {
    firstName: false,
    lastName: false,
    email: false,
    password: false,
    confirmPassword: false,
    general: false,
  }

  confirmPolicy: boolean = false
  confirmAge: boolean = false
  confirmTerms: boolean = false
  acceptNotifications: boolean = false
  subscribeNewsletter: boolean = false

  onReady(): void | Promise<void> {
    this.onChangeCb = Callback.attach(this.onChange.bind(this))
    this.rerender()
  }

  async redirectToLogin() {
    const mainModule = MainModule.getInstance()
    const lang = mainModule.getLang()
    const routing = mainModule.getRouting()

    try {
      await mainModule.analyticsTrack('page_inscription_cta_login', {})
    } catch (error) {
      console.error('Error tracking analytics event:', error)
    }

    routing.goTo(Routing.ROUTES[lang].login)
  }

  onChange() {
    // Get values of all the inputs
    const inputIds = ['email', 'password', 'confirm-password']

    const requiredCheckboxIds = ['confirmPolicy', 'confirmAge', 'confirmTerms']
    const values = inputIds.reduce(
      (acc, id) => {
        const element = this.select(`[name=\"${id}\"]`) as HTMLInputElement
        acc[id] = element?.value || ''
        return acc
      },
      {} as { [key: string]: string }
    )

    // Check if there are any non-empty values
    const hasValues = Object.values(values).some(value => value.trim() !== '')

    // Set the page to dirty or clearDirty accordingly
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    if (hasValues) {
      routing.setDirty()
    } else {
      routing.clearDirty()
    }

    // if all inputs are filled, enable the submit button
    const allInputsFilled = Object.values(values).every(value => value.trim() !== '')

    this.submitButtonDisabled = !allInputsFilled
  }

  async onSignup(): Promise<void> {
    const mainModule = MainModule.getInstance()

    const emailElement: any = this.select('[name="email"]')
    const email = unescapeHtml(emailElement?.value || '')

    const passwordElement: any = this.select('[name="password"]')
    const password = unescapeHtml(passwordElement?.value || '')

    const confirmPasswordElement: any = this.select('[name="confirm-password"]')
    const confirmPassword = unescapeHtml(confirmPasswordElement?.value || '')

    for (const key in this.errors) {
      this.errors[key] = false
    }

    if (!email) {
      this.errors.email = Locale.getKey('signup.errors.email')
    }

    if (!password) {
      this.errors.password = Locale.getKey('signup.errors.password')
    }

    if (password && password.length < 8) {
      this.errors.password = Locale.getKey('signup.errors.passwordLength')
    }

    if (password && !PASSWORD_REGEX.test(password)) {
      this.errors.password = Locale.getKey('signup.errors.passwordCriterias')
    }

    if (email && !EMAIL_REGEX.test(email)) {
      this.errors.email = Locale.getKey('signup.errors.emailInvalid')
    }

    if (password !== confirmPassword) {
      this.errors.confirmPassword = Locale.getKey('signup.errors.confirmPassword')
    }

    let hasErrors = false
    for (const key in this.errors) {
      if (this.errors[key]) {
        hasErrors = true
      }
    }

    if (hasErrors) {
      this.rerender()
      return
    }

    const options = {
      lang: mainModule.getLang(),
    }

    if (email && password) {
      mainModule.getRouting().clearDirty()
      this.submitButtonDisabled = true
      this.loading = true
      let result = await mainModule.getAuth().createUser(email, password, options)

      if (result?.success) {
        await mainModule.getAuth().login(email, password, true) // Redirect logic is in this function

        //const routing = mainModule.getRouting()
        //const lang = mainModule.getLang()
        // We send the user to his account page with a query param to show the complete profile
        //routing.goTo(`${Routing.ROUTES[lang].profile}`)
      } else {
        this.submitButtonDisabled = false
        this.loading = false
        if (result?.error?.status === 'user already exists') {
          if (result?.error?.provider) {
            this.errors.email = Locale.getKey(
              `signup.errors.emailAlreadyExistsWithProvider.${result?.error?.provider}`
            )
          } else {
            this.errors.email = Locale.getKey('signup.errors.emailAlreadyExists')
          }
        } else {
          this.errors.general = Locale.getKey('signup.errors.general')
        }
        this.rerender()
      }
    }
  }

  async onSignupWithGoogle(): Promise<void> {
    this.loading = true
    const mainModule = MainModule.getInstance()
    await mainModule.analyticsTrack('sign_up', {
      method: 'Google',
    })
    await mainModule.getAuth().callGoogleSignIn(true)
    this.loading = false
  }

  async onSignupWithFacebook(): Promise<void> {
    this.loading = true
    const mainModule = MainModule.getInstance()
    await mainModule.analyticsTrack('sign_up', {
      method: 'Facebook',
    })
    await mainModule.getAuth().callFacebookSignIn(true)
    this.loading = false
  }

  openTooltip() {
    this.tooltipOpened = true
  }

  closeTooltip() {
    this.tooltipOpened = false
    const tooltip = this.select('#password-tooltip')
    tooltip?.classList.remove('open')
  }

  handleInput(event: Event) {
    const passwordCriteriaList = this.selectAll('#password-tooltip li')
    const passwordInput = this.select('[name="password"]')

    if (!passwordInput) {
      console.error('Password input not found')
      return
    }

    const value = unescapeHtml((passwordInput as HTMLInputElement).value)

    this.valuePasswordInput = value

    let allCriteriaMet = true // Assume all criteria are met initially

    passwordCriteriaList?.forEach((criteria, index) => {
      const isCriteriaMet = this.checkPasswordCriteria(value, index + 1)

      switch (index + 1) {
        case 1:
          this.passwordLengthValid = isCriteriaMet
          break
        case 2:
          this.passwordUpperCaseValid = isCriteriaMet
          break
        case 3:
          this.passwordLowerCaseValid = isCriteriaMet
          break
        case 4:
          this.passwordNumberValid = isCriteriaMet
          break
        case 5:
          this.passwordSpecialCharValid = isCriteriaMet
          break
      }

      criteria.classList.toggle('valid', isCriteriaMet)
      criteria.classList.toggle('invalid', !isCriteriaMet)

      if (!isCriteriaMet) {
        allCriteriaMet = false
      }
    })

    // set the allPasswordCriteriasMet to the value of allCriteriaMet
    // so we know if all criterias are met
    this.allPasswordCriteriasMet = allCriteriaMet

    if (
      this.passwordLengthValid &&
      this.passwordUpperCaseValid &&
      this.passwordLowerCaseValid &&
      this.passwordNumberValid &&
      this.passwordSpecialCharValid
    ) {
      setTimeout(() => {
        this.closeTooltip()
      }, 1000)
    } else {
      if (!this.tooltipOpened) this.openTooltip()
    }

    this.rerender()
  }

  checkPasswordCriteria(password: string, criteriaIndex: number): boolean {
    switch (criteriaIndex) {
      case 1:
        return password.length >= 8
      case 2:
        return /[A-Z]/.test(password)
      case 3:
        return /[a-z]/.test(password)
      case 4:
        return /\d/.test(password)
      case 5:
        return /[!@#$%^&*(),.?":{}|<>]/.test(password)
      default:
        return false
    }
  }

  // Add a helper method to render each password criteria
  renderPasswordCriteria(pointKey: string, isValid: boolean): string {
    if (this.valuePasswordInput.length === 0) {
      return `<li class="password-criteria">
      <lvc-blue-x-icon></lvc-blue-x-icon>
      ${Locale.getKey(pointKey)}
    </li>`
    }

    return `
    <li class="password-criteria ${isValid ? 'valid' : 'invalid'}">
      ${isValid ? `<lvc-green-checkmark-icon></lvc-green-checkmark-icon>` : `<lvc-red-x-icon></lvc-red-x-icon>`}
      ${Locale.getKey(pointKey)}
    </li>
  `
  }

  html = () => `

  <lvc-auth-layout>
     <!-- Menu slot for the signup screen -->
    <div slot="auth-menu" class="auth-menu">
      <div class="auth-menu-header">
        <h1 class="title">${Locale.getKey('signup.menu.title')}</h1>
        <p class="subtitle">${Locale.getKey('signup.menu.subtitle')}</p>
        <button class="auth-menu-button" id="signin-button">${Locale.getKey('signup.menu.login')}</button>
        <div slot="icon">
          <lvc-charlie-hands-together width="235px" height="auto"></lvc-charlie-hands-together>
        </div>
      </div>
    </div>

    <!-- Form slot for signup fields -->
    <div slot="auth-form" class="auth-form">
      <div class="form-header">
      <div slot="auth-toggle">
      <div class="toggle-container">
        <button class="toggle-on" name="toggle-signup" id="toggle-signup">
          ${Locale.getKey('signup.menu.toggle.signup')}
        </button>
        <button class="toggle" name="toggle-login" id="signin-button">
          ${Locale.getKey('signup.menu.toggle.login')}
        </button>
      </div>
    </div>
        <h1 class="title">${Locale.getKey('signup.form.title')}</h2>
        <p class="subtitle">${Locale.getKey('signup.form.subtitle')}</p>
        <p class="subtitle">${Locale.getKey('signup.form.notice')}</p>
        <div class="sso-buttons-container">
          <button class="sso-button" id="google-sign-provider-button"><lvc-google-icon></lvc-google-icon>${Locale.getKey('signup.menu.google')}</button>
          <button class="sso-button" id="facebook-sign-provider-button"><lvc-facebook-icon variant="simple"></lvc-facebook-icon>${Locale.getKey('signup.menu.facebook')}</button>
        </div>
        <div class="divider-wrapper">
          <div class="divider-line"></div>
          <div class="divider-text">${Locale.getKey('signup.form.divider')}</div>
          <div class="divider-line"></div>
        </div>
      </div>
      <div class="form-group">
        <div class="email-container">
          <lvc-input type="text" value="${this.email}" error="${this.errors.email}" default-value="${this.email}" name="email" label="${Locale.getKey('signup.email.label')}" placeholder="${Locale.getKey('signup.email.placeholder')}" height="56px" on-change="${this.onChangeCb}"></lvc-input>
        </div>
        <div class="passwords">
          <div class="password-container">
            <lvc-input type="password" id="password" value="${this.password}" error="${this.errors.password}" default-value="${this.password}" name="password" label="${Locale.getKey('signup.password.label')}" placeholder="${Locale.getKey('signup.password.placeholder')}" height="56px" width="100%" on-change="${this.handleInputCb}"></lvc-input>
            <dialog id="password-tooltip" class="tooltip ${this.tooltipOpened ? `open` : ``}">
              <lvc-pointy-popup-arrow></lvc-pointy-popup-arrow>
              <div class="content-dialog">
                <div class="password-tooltip-content" slot="tooltip-content">
                  <h3>${Locale.getKey('signup.password.tooltip.title')}</h3>
                  <ul class="password-tooltip">
                  ${this.renderPasswordCriteria('signup.password.tooltip.point1', this.passwordLengthValid)}
                  ${this.renderPasswordCriteria('signup.password.tooltip.point2', this.passwordUpperCaseValid)}
                  ${this.renderPasswordCriteria('signup.password.tooltip.point3', this.passwordLowerCaseValid)} 
                  ${this.renderPasswordCriteria('signup.password.tooltip.point4', this.passwordNumberValid)}
                  ${this.renderPasswordCriteria('signup.password.tooltip.point5', this.passwordSpecialCharValid)}
                </ul>
                </div>
              </div>
            </dialog>
          </div>

          <div class="confirm-password-container">
            <lvc-input type="password" value="${this.confirmPassword}" error="${this.errors.confirmPassword}" default-value="${this.confirmPassword}" name="confirm-password" label="${Locale.getKey('signup.confirmPassword.label')}" placeholder="${Locale.getKey('signup.confirmPassword.placeholder')}" height="56px" width="100%" on-change="${this.onChangeCb}"></lvc-input>
          </div>
        </div>
        <div class="save-button">
          <button id="btn-save" class="btn-save">
            ${Locale.getKey('signup.submit')}
            ${this.loading ? `<div class="btn-loader"></div>` : ` <lvc-simple-arrow-right-icon width="28px" height="28px"><lvc-simple-arrow-right-icon />`} </button>
        </div>
      </div>
      <!-- Desktop footer icon slot -->
      <div slot="footer-icon" class="footer-icon">
        <lvc-charlie-waving-icon width="235px" height="auto"></lvc-charlie-waving-icon>
      </div>
      
      <!-- Mobile footer icon slot -->
      <div slot="footer-icon-mobile" class="charlie-icon-mobile">
        <lvc-charlie-hands-together width="235px" height="auto" variant="cropped"></lvc-charlie-hands-together>
      </div>
    </lvc-auth-layout>
    
  `

  css = () => `
    :host {
    }
    a {
      color: #1E007D;
    }
    .divider-wrapper {
      display: flex;
      align-items: center;
      margin-top: 1rem;
    }
    .divider-text {
      padding-left: 8px;
      padding-right: 8px;
      font-size: 14px;
    }
    .divider-line {
      height: 1px;
      background: white;
      flex-grow: 1;
    }
    .btn-loader {
      border: 2px solid #fff;
      border-top: 2px solid transparent;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .charlie-icon-mobile {
      display: none;
    }

    [slot="icon"] > lvc-charlie-hands-together {
      display: flex;
      position: absolute;
      bottom: -8px;
      right: 50px;
    }

    .toggle-container {
      display: none;
    }

    lvc-charlie-waving-icon {
      display: flex;
      justify-content: flex-end;
      z-index: 1;
    }

    .footer-icon {
      position: absolute;
      bottom: 0px;
      right: 40px;
    }

    lvc-google-icon, lvc-facebook-icon {
      display: flex;
      align-items: center;
    }
    
    .sso-buttons-container {
      display: flex;
      justify-content: center;
      flex-direction: row;
      gap: 0.5rem;
      flex-wrap: wrap;
    }

    button {
      cursor: pointer;
      font-family: inherit;
    }

    .btn-save{
      margin-top: 1rem;
      background-color: #1E007D;
      color: white;
      padding: 1rem 2rem;
      padding-right: 1.5rem;
      border: none;
      border-radius: 99px;
      font-weight: ${Font.weight.medium};
      cursor: pointer;
      outline: none;
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 14px;
    }
    .btn-save:hover {
      background: linear-gradient(131.14deg, #1E007D 19.64%, #000FE3 94.07%);
    }

    .save-button{
      display: flex;
      justify-content: center;
      z-index: 10;
    }

    .sso-button {
      font-size: 14px;
      background: transparent;
      color: #1E007D;
      border: 1px solid #1E007D;
      border-radius: 99px;
      height: 56px;
      font-weight: ${Font.weight.medium};
      font-family: inherit;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      gap: 8px;
      text-wrap: nowrap;
      flex-grow: 1;
      min-width: 230px;
      transition: transform 0.2s;
    }
    .sso-button:hover {
      transform: scale(1.03);
    }

    .auth-form{
      display: flex;
      flex-direction: column;
      gap: 2rem;
      pointer-events: ${this.loading ? 'none' : 'auto'};
    }

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }


    .passwords {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      justify-content: space-between;
      align-items: flex-end;
    }

    .confirm-password-container, .password-container {
      width: 100%;
    }

    .password-container {

      position: relative;
    }



    .title {
      font-size: 2.5rem;
      line-height: 1.1;
      font-weight: ${Font.weight.extraBold};
      margin: 0;
      color: #1E007D;
    }

    .subtitle {
      font-size: 14px;
      margin: 0;
      font-weight: ${Font.weight.medium};
    }

    .auth-menu-header {
      display: flex;
      flex-direction: column;
      gap: 2rem;
    }

    .form-header {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .auth-menu-button{
      border: none;
      background: transparent;
      color: #1E007D;
      width: fit-content;
      padding: 1rem 2rem;
      font-weight: ${Font.weight.medium};
      font-family: inherit;
      position: relative;
    }
    .auth-menu-button::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 999px;
      padding: 2px; /* control the border thickness */
      background: linear-gradient(45deg, #1E007D, #1E007D);
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }
    .auth-menu-button:hover {
      background: linear-gradient(131.14deg, #1E007D 19.64%, #000FE3 94.07%);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }
    .auth-menu-button:hover::before {
      background: linear-gradient(131.14deg, #1E007D 19.64%, #000FE3 94.07%);
    }

    .content-dialog{
      display:flex;

    }

    .urls{
      font-style: normal;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      text-decoration: underline;
      color: #1E007D;
    }

    a>u:hover, .urls:hover {
      color: #FFF;
    }
    
    .password-tooltip-content h3 {
      margin: 0 0 8px;
    }
    
    .password-tooltip-content ul {
      margin: 0;

    }

    lvc-pointy-popup-arrow{
      z-index: 1;
      position: absolute;
      top: -11px;
      right: 10px;
    }

    .tooltip.open {
      margin-top: 15px;
      display: block;
      z-index: 15;
      border: 1px solid rgba(30, 0, 125, 0.3);
      box-shadow: 0px 4px 16px rgba(15, 0, 62, 0.15);
      border-radius: 8px;
      padding: 16px;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      line-height: 150%;
      color: #1E007D;
      max-width: 90vw;
      width: 340px;
      margin-left: auto;
      margin-right: 0;
    }

    .password-tooltip-content ul {
      margin: 0;
      padding: 0;
      list-style: none; /* Remove default list style */
    }

    .password-tooltip-content li {
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      letter-spacing: 0px;
      text-align: left;
      
    }
    
    .password-tooltip-content li::before {
      content: ''; /* Empty content to remove default bullet point */
      display: inline-block;
      width: 9px;
      height: 10px;
      margin-right: 8px;
    }

    .password-criteria {
      display:flex;
      align-items: center;
      margin-top: 8px;
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      color: #1E007D;
    }

    lvc-blue-x-icon, lvc-green-checkmark-icon, lvc-red-x-icon {
      margin-right: 10px;
    }

    .password-criteria.valid {
      color: green;
    }

    .password-tooltip-content li.valid {
      color: green;
    }

    .password-criteria.invalid {
      color: red;
    }
    
    label {
      font-family: inherit;
      color: #1E007D;
      font-size: 14px;
      line-height: 17px;
      font-weight: ${Font.weight.bold};
      margin-bottom: 4px;
    }

    @media only screen and (max-width: 991px) {
      .passwords {
        align-items: flex-end;
        flex-direction: column;
      }

      .sso-buttons-container {
        flex-direction: column;
        gap: 1rem;
      }

      lvc-charlie-waving-icon {
        display: none;
      }
      .charlie-icon-mobile {
        display: flex;
        justify-content: center;
      }

      .charlie-icon-mobile lvc-charlie-hands-together {
        display:flex;
      }

      .toggle-container {
        display: flex;
        justify-content: center;
        border-radius: 99px;
        padding: 3px;
        border: 1px solid #1E007D;
      }

      .toggle {
        background: transparent;
        color: #1E007D;
        border: none;
        font-weight: ${Font.weight.medium};
        font-family: inherit;
        cursor: pointer;
        padding: 1rem;
        outline: none;
        width: 100%;
      }

      .toggle-on {
        background: #1E007D;
        color: white;
        border-radius: 99px;
        border: none;
        font-weight: ${Font.weight.medium};
        font-family: inherit;
        cursor: pointer;
        padding: 1rem;
        outline: none;
        width: 100%;
      }


    }
  `

  eventListeners: EventListeners = [
    ['#btn-save', 'click', this.onSignup.bind(this)],
    ['#google-sign-provider-button', 'click', this.onSignupWithGoogle.bind(this)],
    ['#facebook-sign-provider-button', 'click', this.onSignupWithFacebook.bind(this)],
    ['[name="password"]', 'focus', this.openTooltip.bind(this)],
    ['[name="password"]', 'blur', this.closeTooltip.bind(this)],
    ['#signin-button', 'click', this.redirectToLogin.bind(this)],
  ]
}
